import { publicClient, privateClient } from './client';
import { SetDefaultStore } from './SetDefaultStore';

const customSetDefaultStore = (pub: boolean) => new SetDefaultStore(pub ? publicClient : privateClient);
export default customSetDefaultStore;
